import mergeWith from 'lodash/mergeWith'

export function isTruthy(val: any) {
  return val !== null && val !== undefined && !(typeof val === 'string' && val.trim() === '')
}

export function customMerge(obj1: any, obj2: any) {
  return mergeWith({}, obj1, obj2, (value1, value2) => {
    const val1Truthy = isTruthy(value1)
    const val2Truthy = isTruthy(value2)

    if (val1Truthy && val2Truthy) {
      return value2
    } else if (val1Truthy && !val2Truthy) {
      return value1
    } else if (!val1Truthy && val2Truthy) {
      return value2
    } else {
      return null
    }
  })
}
